import React from 'react';
import {Button, Modal} from 'antd';
import {useTranslation} from 'react-i18next';

interface AbandonConfirmModalProps {
    open: boolean;
    loading?: boolean;
    onCancel: () => void;
    onConfirm: () => void;
}

/**
 * 放弃申诉/主动认责 共用确认弹窗。
 * 按钮文案 + content 文案对两种状态保持一致（用户视角无差别），
 * 实际调用的接口由调用方决定（acknowledgeCustomerComplaint / abandonCustomerComplaintAppeal）。
 *
 * 范式对齐项目内下载/导出弹窗：<Modal> JSX + 手写 footer + type="primary"。
 */
const AbandonConfirmModal: React.FC<AbandonConfirmModalProps> = ({
    open,
    loading,
    onCancel,
    onConfirm,
}) => {
    const {t} = useTranslation();
    return (
        <Modal
            title={t('customerComplaint.drawer.abandonConfirmTitle')}
            open={open}
            onCancel={onCancel}
            width={520}
            destroyOnClose
            footer={[
                <Button key="cancel" onClick={onCancel}>
                    {t('common.cancel')}
                </Button>,
                <Button key="ok" type="primary" loading={loading} onClick={onConfirm}>
                    {t('customerComplaint.drawer.abandonConfirmOk')}
                </Button>,
            ]}
        >
            <div className="text-sm text-gray-700">
                {t('customerComplaint.drawer.abandonConfirmContent')}
            </div>
        </Modal>
    );
};

export default AbandonConfirmModal;
